import React, { Component } from 'react';
import Formulario from './SalidasForm';
import LoadMask from "../../Utils/LoadMask/LoadMask";

class Salidas extends Component{
    state = {
        crear: true,
    }

    componentDidMount = () => {
        const { match, leer, getModulo,leerPeriodoD,
        leerDetalleProductos, parametrosEmpresa, listarSeries } = this.props;
        const id = match.params.id;
        if (id){
            this.setState({crear: false});
            leer(id);
        }
        let ruta = window.location.href;
        let periodo = ruta.split('/');
        leerPeriodoD(periodo[5], periodo[7]);
        getModulo(periodo[5], periodo[4]);
        parametrosEmpresa();
        listarSeries();
        leerDetalleProductos('00000000-0000-0000-0000-000000000000');
        localStorage.removeItem('id_detalle_inventario_salida');
    }
    
    render(){
        const { loader, modulo, lectura, periodoD, datos, listarBodegas, pro,
            detalleProducto, registroProductoInventario, leerProductosFarm,
            eliminarLineaProducto, confirmarSalida, leerProductos,
            proFarm, leerLotes, lotes, listarSeries, numeroSerie, modificarSalida } = this.props;
        const { crear } = this.state;
        return(
            <LoadMask loading={loader} dark>
                <Formulario
                    crear = {crear}
                    modulo = {modulo}
                    lectura = {lectura}
                    periodoD = {periodoD}
                    datos = {datos}
                    detalleProducto = {detalleProducto}
                    registroProductoInventario = {registroProductoInventario}
                    eliminarLineaProducto = {eliminarLineaProducto}
                    confirmarSalida = {confirmarSalida}
                    listarBodegas = {listarBodegas}
                    leerProductos = {leerProductos}
                    pro = {pro}
                    leerProductosFarm = {leerProductosFarm}
                    proFarm = {proFarm}
                    leerLotes = {leerLotes}
                    lotes = {lotes}
                    listarSeries = {listarSeries}
                    numeroSerie = {numeroSerie}
                    modificarSalida = {modificarSalida}
                />
            </LoadMask>
        );
    }
}

export default Salidas
